import React, { useState, useContext, useEffect, useMemo, useRef } from 'react'
import { Calendar } from 'primereact/calendar'
import { LocalShippingOutlined, TimelineOutlined, RouteOutlined, CalculateOutlined } from '@mui/icons-material'
import LineChartV1 from '../Charts/LineChartV1'
import ColumnChart from '../Charts/ColumnChart'
import DoughnutChartV1 from '../Charts/doughnutChartV1'
import { Menu } from '@mui/material'
import { BufferService } from '../M_Components'
import { M_Button } from '../M_Components'
import { LoadingContext } from '../M_Components'
import { M_DrawerTableTextField } from '../M_Components'
import { useTranslation } from 'react-i18next'
import './dashboard.css'

export default function Dashboard() {

  let firstDay = new Date(new Date().getFullYear(), 0, 1)
  let today = new Date()
  let month = today.getMonth()
  let year = today.getFullYear()
  let prevMonth = (month === 0) ? 11 : month - 1
  let prevYear = (prevMonth === 11) ? year - 1 : year
  let nextMonth = (month === 11) ? 0 : month + 1
  let nextYear = (nextMonth === 0) ? year + 1 : year
  let arrayDate = [firstDay, today]
  let minDate = new Date()
  minDate.setMonth(prevMonth)
  minDate.setFullYear(prevYear)
  let maxDate = new Date()
  maxDate.setMonth(nextMonth)
  maxDate.setFullYear(nextYear)

  const [anchorEl, setAnchorEl] = useState(false)
  const [rangeDate, setRangeDate] = useState([firstDay, today])
  const [filtersMap, setFiltersMap] = useState(new Map())
  const [dataDashboard, setDataDashboard] = useState([])
  const bufferServiceDashboard = useMemo(() => new BufferService('Dashboard/GetMetrics'), [])
  const ctx = useContext(LoadingContext)
  const { t } = useTranslation()
  const open = Boolean(anchorEl)

  const cardsDashboard = useMemo(() => (dataDashboard ? [
    { name: t("ServiceOrder"), value: dataDashboard?.Kpis?.TotalServiceOrders || 0, icon: <LocalShippingOutlined className='iconCardDashboard' />, color: '#E2CC00' },
    { name: t("ServiceOrderInExecution"), value: dataDashboard?.Kpis?.TotalExecutionServiceOrders || 0, icon: <TimelineOutlined className='iconCardDashboard' />, color: '#299C00' },
    { name: t("MediaKm"), value: (dataDashboard?.Kpis?.ServiceOrderAverageKm ?? 0).toFixed(2) + " Km", icon: <RouteOutlined className='iconCardDashboard' />, color: '#007FFF' },
    { name: t("Quotes"), value: dataDashboard?.Kpis?.TotalQuotes || 0, icon: <CalculateOutlined className='iconCardDashboard' />, color: '#E41B27' }
  ] : []), [dataDashboard, t])

  const hasAnimatedRef = useRef(false)
  const [enableChartAnimation, setEnableChartAnimation] = useState(true)

  const listFiltersDashboard = [
    { Name: 'Driver', NormalizedName: t("Driver"), Type: 'string', Entity: "Driver", ForeignTableToPassId: "DriverId", ForeignKeyName: "Name" },
    { Name: 'Customer', NormalizedName: t("Customer"), Type: 'string', Entity: "Customer", ForeignTableToPassId: "CustomerId", ForeignKeyName: "Name" },
    { Name: 'ServiceOrderState', NormalizedName: t("Status"), Type: 'string', Entity: "ServiceOrderState", ForeignTableToPassId: "ServiceOrderStateId", ForeignKeyName: "Name" },
    { Name: 'Transport', NormalizedName: t("Transport"), Type: 'string', Entity: "Transport", ForeignTableToPassId: "TransportId", ForeignKeyName: "LicensePlate" },
  ]

  const dataKmsDrivers = useMemo(() => ({
    labels: dataDashboard?.BarCharts?.DriverKmCounts.map(item => item.DriverName) ?? [],
    datasets: [
      {
        label: t("TotalKms"),
        backgroundColor: '#FF4550',
        borderColor: '#FF4550',
        data: dataDashboard?.BarCharts?.DriverKmCounts.map(item => item.TotalKms) ?? []
      }
    ]
  }), [dataDashboard, t])

  const dataServiceorderByState = useMemo(() => ({
    labels: dataDashboard?.BarCharts?.ServiceOrdersByState.map(item => item.State) ?? [],
    datasets: [
      {
        label: t('Status'),
        backgroundColor: '#FF4550',
        borderColor: '#FF4550',
        data: dataDashboard?.BarCharts?.ServiceOrdersByState.map(item => item.Total) ?? []
      }
    ]
  }), [dataDashboard, t])

  const dataMonthYearKmCounts = useMemo(() => ({
    labels: dataDashboard?.LineCharts?.MonthYearKmCounts.map(item => item.MonthYear) ?? [],
    datasets: [
      {
        label: t("TotalKms"),
        backgroundColor: '#FF4550',
        borderColor: '#FF4550',
        data: dataDashboard?.LineCharts?.MonthYearKmCounts.map(item => item.TotalKms) ?? []
      }
    ]
  }), [dataDashboard, t])


  function toJSONLocal(date) {
    var local = new Date(date)
    local.setMinutes(date.getMinutes() - date.getTimezoneOffset())
    return local.toJSON().slice(0, 10)
  }

  const initialDateFilters = () => {
    const map = new Map()
    map.set("StartDate", toJSONLocal(firstDay))
    map.set("EndDate", toJSONLocal(today))
    return map
  }

  const clearAllFilters = () => {
    const initialFilters = initialDateFilters()
    setFiltersMap(initialFilters)
    setRangeDate([firstDay, today])
    submitFilters(initialFilters)
  }

  useEffect(() => {
    const initialFilters = new Map()
    initialFilters.set("StartDate", toJSONLocal(firstDay))
    initialFilters.set("EndDate", toJSONLocal(today))
    setFiltersMap(initialFilters)

    submitFilters(initialFilters)
  }, [])

  const rangeDates = (e) => {
    setRangeDate(e)
    if (e[0] !== null && e[1] !== null) {
      filtersMap.set('StartDate', toJSONLocal(e[0]))
      filtersMap.set('EndDate', toJSONLocal(e[1]))
      setFiltersMap(new Map(filtersMap))
      submitFilters(filtersMap)

    } else {
      ctx.toastMessages('error', '', t("SelectAnotherDate"))
    }
  }

  const selectFilter = (key, value) => {
    filtersMap.set(key, value)
    setFiltersMap(new Map(filtersMap))
    console.log("filtersMap", filtersMap)
  }

  const buildFiltersObject = (filtersMap) => {
    const obj = {}

    filtersMap.forEach((value, key) => {
      if (value !== '' && value != null) {
        if (typeof value === 'string' && value.includes(',')) {
          obj[key.charAt(0) + key.slice(1)] = value.split(',').map(v => v.trim())
        } else {
          obj[key.charAt(0) + key.slice(1)] = value
        }
      }
    })
    return obj
  }

  const submitFilters = (passFilter) => {
    const tempFilter = passFilter || filtersMap
    const filtersObject = buildFiltersObject(tempFilter)

    ctx.setIsLoad(true)
    bufferServiceDashboard.post(filtersObject).then((res) => {
      if (res.name === 'AxiosError') {
        ctx.toastMessages("error", "", t("ErrorLoadingDashboard"))
        ctx.setIsLoad(false)
        return
      }

      setDataDashboard(res)
      if (!hasAnimatedRef.current) {
        setEnableChartAnimation(true)
        hasAnimatedRef.current = true
      } else {
        setEnableChartAnimation(false)
      }
      ctx.setIsLoad(false)
    })
  }


  return (
    <>
      <div className='headerDashboard'>
        <div className='divTitleHeaderDashboard'>
          Dashboard
        </div>
        <div className='divFiltersDashboard'>
          <M_Button
            icon={<img src='/icons/svgsDaNet/refresh.svg' style={{ filter: "", width: '25px' }} alt='refresh' />}
            backgroundColor={"var(--color-grey-light)"}
            tooltip={t("Refresh")}
            height={"35px !important"}
            onClick={() => submitFilters(filtersMap)}
          />
          <Calendar
            dateFormat="dd/mm/yy"
            value={rangeDate}
            onChange={(e) => rangeDates(e.target.value)}
            selectionMode="range"
            readOnlyInput
            showIcon
            showButtonBar
            className='calendarDashboard'
            style={{ width: '300px' }}
          />
          <div className='divButtonFiltersDashboard' onClick={(e) => setAnchorEl(e.currentTarget)}>
            <img src='/icons/svgsDaNet/filter.svg' alt='refresh' className="iconFilter" />
            {t("Filters")}
          </div>

          <Menu
            anchorEl={anchorEl}
            open={open}
            onClose={() => setAnchorEl(null)}
            className="organizeMenuSearch"
            MenuListProps={{ disablePadding: true }}
          >
            <div className='divPrincipalFiltersOrderService' >
              {listFiltersDashboard.map((elem, key) => (
                <div key={key} className='divIndividualFilter'>
                  <M_DrawerTableTextField
                    tableLabel={elem.NormalizedName}
                    entity={elem.Entity}
                    label={elem.NormalizedName}
                    value={
                      filtersMap.get(elem.ForeignTableToPassId)
                        ? {
                          [elem.ForeignTableToPassId]: filtersMap.get(elem.ForeignTableToPassId),
                          [elem.ForeignKeyName]: filtersMap.get(elem.Name),
                        }
                        : null
                    }
                    filterField={elem.ForeignKeyName}
                    labelFields={[elem.ForeignKeyName]}
                    onSubmitValue={obj => {
                      if (obj) {
                        console.log("obj", obj)
                        // const values = Array.isArray(obj)
                        //   ? obj.map(o => o[elem.ForeignTableToPassId]).filter(v => v != null)
                        //   : [obj[elem.ForeignTableToPassId]].filter(v => v != null)

                        selectFilter(elem.ForeignTableToPassId, [obj[elem.ForeignTableToPassId]])
                        selectFilter(elem.Name, obj[elem.ForeignKeyName])
                      } else {
                        selectFilter(elem.ForeignTableToPassId, [])
                      }
                    }}
                    valueField={elem.ForeignTableToPassId}
                  // multiple
                  />
                </div>
              ))}

            </div>
            <div className='stickyBot'>
              <div className='divButtonsFilters'>
                <M_Button
                  backgroundColor={"var(--color-red-dark)"}
                  labelColor={"var(--color-white"}
                  label={t("ClearFilters")}
                  icon={<img src="/icons/svgsDaNet/trash-2.svg"
                    style={{ filter: 'invert(100%) sepia(0%) saturate(1460%) hue-rotate(64deg) brightness(107%) contrast(100%)', width: '24px' }}
                    alt="clear" />
                  }
                  onClick={() => clearAllFilters()}
                />
                <M_Button
                  backgroundColor={"var(--color-green)"}
                  labelColor={"var(--color-white"}
                  label={t("ApplyFilters")}
                  icon={<img src="/icons/svgsDaNet/file-plus.svg"
                    style={{ filter: 'invert(100%) sepia(0%) saturate(1460%) hue-rotate(64deg) brightness(107%) contrast(100%)', width: '24px' }}
                    alt="save" />
                  }
                  onClick={() => submitFilters()}
                />
              </div>
            </div>
          </Menu>
        </div>
      </div>

      <div className='divPrincipalCardsDashboard'>
        {cardsDashboard.map((value, index) => (
          <div key={index} className='divCardsDashboard'>
            <div className='divIconCard' style={{ backgroundColor: value.color }}>
              {value.icon}
            </div>
            <div className='divTextCards'>
              <div className='textCardDashboard'>{value.name}</div>
              <div className='valueCardDashboard'>{value.value}</div>
            </div>
          </div>
        ))}
      </div>

      <div className='divPrincipalChartsDashboard'>
        <div className='divCardChartLineDashboard'>
          <div className='titleChartLine'>
            {t("TotalServicesByStatus")}
          </div>
          <div>
            <ColumnChart
              data={dataServiceorderByState}
              animate={enableChartAnimation}
            />
          </div>
        </div>
        <div className='divCardChartLineDashboard'>
          <div className='titleChartLine'>
            {t("TotalKmsByDriver")}
          </div>
          <div>
            <ColumnChart
              data={dataKmsDrivers}
              animate={enableChartAnimation}
            />
          </div>
        </div>
      </div>

      <div className='divPrincipalChartsColumnDashboard'>
        <div className='divChartColumnDashboard'>
          <div className='titleChartLine'>
            {t("TotalKmsByMonth")}
          </div>
          <LineChartV1
            data={dataMonthYearKmCounts}
            animate={enableChartAnimation}
          />
        </div>

        <div className='divChartDoughnutDashboard'>
          <div className='divPrincipalDoughnut'>
            <div className='titleChartLine'>
              {t("Vehicle")}
            </div>
            <div className='DivChartDoughnut'>
              <DoughnutChartV1
                value1={dataDashboard?.DonutCharts?.Transports?.Total - dataDashboard?.DonutCharts?.Transports?.Available || 0}
                value2={dataDashboard?.DonutCharts?.Transports?.Available || 0}
                labels={[t("Used"), t("Available")]}
                animate={enableChartAnimation}
              />
            </div>
          </div>
          <div className='divPrincipalDoughnut'>
            <div className='titleChartLine'>
              {t("Trailer")}
            </div>
            <div className='DivChartDoughnut'>
              <DoughnutChartV1
                value1={dataDashboard?.DonutCharts?.Trailers?.Total - dataDashboard?.DonutCharts?.Trailers?.Available || 0}
                value2={dataDashboard?.DonutCharts?.Trailers?.Available || 0}
                labels={[t("Used"), t("Available")]}
                animate={enableChartAnimation}
              />
            </div>
          </div>
          <div className='divPrincipalDoughnut'>
            <div className='titleChartLine'>
              {t("Driver")}
            </div>
            <div className='DivChartDoughnut'>
              <DoughnutChartV1
                value1={dataDashboard?.DonutCharts?.Drivers?.Total - dataDashboard?.DonutCharts?.Drivers?.Available || 0}
                value2={dataDashboard?.DonutCharts?.Drivers?.Available || 0}
                labels={[t("Used"), t("Available")]}
                animate={enableChartAnimation}
              />
            </div>
          </div>
        </div>
      </div>
      <br />
    </>
  )
}